/**
 * TanStack Query Client (shared singleton)
 *
 * Exported from a dedicated module so that both App.tsx (provider)
 * and utility modules (e.g., auth.ts) can import it without creating
 * a circular dependency through the application root.
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});
